import { initMockStores } from './MockStores';

initMockStores();
